module.exports = __webpack_public_path__ + "static/media/mcc-end.aab7741e.svg";